import './SocialLinks.css'

function SocialLinks() {
  const socialLinks = [
    { name: 'Twitter', url: '#', icon: '𝕏' },
    { name: 'Facebook', url: '#', icon: 'f' },
    { name: 'Instagram', url: '#', icon: '📷' },
    { name: 'TikTok', url: '#', icon: '♪' },
    { name: 'YouTube', url: '#', icon: '▶' }
  ]

  return (
    <div className="social-links">
      {socialLinks.map((link) => (
        <a
          key={link.name}
          href={link.url}
          className="social-icon"
          title={link.name}
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.icon}
        </a>
      ))}
    </div>
  )
}

export default SocialLinks
